import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AtiraIcon } from './AtiraIcon';
import { Button } from './Button';
import { Flex } from './Flex';
import { Text } from './Text';
import { Modal } from './modal/Modal';

const ConfirmButton = styled(Button)`
  background-color: transparent;
  border: ${({ theme }) => `1px solid ${theme.fgPrimary}`};
  height: 2.5rem;
  color: ${({ theme }) => theme.fgPrimary};
  width: 10rem;

  &:hover {
    color: ${({ theme }) => theme.bgCanvas};
    background-color: ${({ theme }) => theme.fgPrimary};
  }
`;

const CancelButton = styled(Button)`
  width: fit-content;
  height: 2.5rem;
  width: 10rem;
  border: ${({ theme }) => `1px solid ${theme.main}`};

  &:hover {
    background-color: ${({ theme }) => theme.mainHover};
    border-color: ${({ theme }) => theme.mainHover};
  }
`;

interface WarningModalProps {
  title?: string;
  description?: string;
  onConfirm?: VoidFunction;
  loading?: boolean;
  open: boolean;
  onClose?: VoidFunction;
  confirmButtonText?: string;
  closeButtonText?: string;

  confirmButtonTestId?: string;
  closeButtonTestId?: string;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  title,
  description,
  onConfirm,
  onClose,
  loading,
  open,
  confirmButtonText,
  closeButtonText,
  confirmButtonTestId,
  closeButtonTestId,
}) => {
  const { t } = useTranslation();

  const onLocalConfirm = () => {
    onConfirm?.();
  };

  return (
    <Modal open={open} onClose={onClose} title={t('common.warning')}>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s"
      >
        <Flex width={'4rem'}>
          <AtiraIcon
            icon={faTriangleExclamation}
            size="4x"
            color="iconPrimary"
          />
        </Flex>

        <Text fontSize="l" align="center">
          {title ? title : t('common.are_you_sure')}
        </Text>

        <Text
          fontSize="m"
          align="center"
          color="fgSecondary"
          style={{ whiteSpace: 'pre-line' }}
        >
          {description ? description : t('forms.delete.modal.description')}
        </Text>

        <Flex gap="m" marginTop="m">
          <CancelButton
            loading={loading}
            onClick={onLocalConfirm}
            dataTestId={confirmButtonTestId}
          >
            {confirmButtonText || t('common.yes')}
          </CancelButton>

          <ConfirmButton onClick={onClose} dataTestId={closeButtonTestId}>
            {closeButtonText || t('common.no')}
          </ConfirmButton>
        </Flex>
      </Flex>
    </Modal>
  );
};
